module.exports = __webpack_public_path__ + "src/assets/textures/leaves/lettuce_leaf_color_map.jpg";